import { getCurrentUser } from "@/auth/firebase";
import { envLocker } from "@/reducers/environments";
import { masqueradeToken, simulatedAccess } from "@/util";

// Apiv2's InternalAuth middleware resolves the caller's account from the
// Firebase token and authorizes the env in X-Env-ID against it. While an
// employee masquerades, that account only has access to the customer's env
// when X-Masquerade-Token is forwarded; without it every request 401s.
// All API_V2_ROOT fetches MUST build their auth headers through this helper
// so the masquerade token can never be dropped at an individual call site.
export async function apiV2AuthHeaders(): Promise<Record<string, string>> {
  const currentUser = getCurrentUser();
  if (!currentUser) {
    throw new Error("Not authenticated");
  }
  const token = await currentUser.getIdToken();

  const headers: Record<string, string> = {
    Authorization: `Bearer ${token}`,
    "X-Env-ID": envLocker.getEnvID() ?? "",
  };

  const masq = masqueradeToken();
  if (masq) {
    headers["X-Masquerade-Token"] = masq;
  }

  // Internal permission-simulation tool: the restricted permission set to
  // evaluate the superuser against.
  const sim = simulatedAccess();
  if (sim) {
    headers["X-Simulate-Permissions"] = JSON.stringify(sim.permissions);
  }

  return headers;
}
